import React from 'react';
import useAsyncDataCourier from '../../common/custom-hooks/useAsyncDataCourier';
import MessageCourier from '../../lib/MessageCourier';
import { Categoria } from '../../system/Categoria/Categoria';
import SystemClient from '../../system/SystemClient';
import ComboBoxSearch, { IComboBoxSearch } from '../Common/ComboBoxSearch';
import { IComboBoxOption } from '@fluentui/react';
import ComboBoxInput from '../../lib/FormValidator/Form/ComboBoxInput';
import CustomInputIfc from '../../lib/FormValidator/Form/CustomInputIfc';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import useForceUpdate from '../../common/custom-hooks/useForceUpdate';
import { AppContext } from '../../AppInRouterContext';
interface ICategoriaSelector {
    appContext: AppContext;
    onSelect: (entity: Categoria) => void;
    selected: string[];
    options?: IComboBoxOption[];
}

export const CategoriaSelector = (props: ICategoriaSelector) => {
    const categorias = useAsyncDataCourier(() => props.appContext.system.getCategoriasListForDropdown(), [], props.appContext.courier)
    const getFromKey = (key: string) => {
        if (categorias) {
            const entity = categorias.find((e) => e.getId() == key);
            if (entity) {
                return props.onSelect(entity);
            }

        }

    };
    const categoriaOptions = React.useMemo(() => {
        let ret: IComboBoxOption[] = [];
        if (categorias) {
            ret = categorias.map((entity: Categoria) => {
                return { key: entity.getId()!, text: String(entity.getNombre()!), data: entity }

            })
        }

        return ret
    }, [categorias])
    return <ComboBoxSearch
    onSelectOption={(opt) => getFromKey(String(opt.key))}

    selected={props.selected}

    options={props.options ? props.options : categoriaOptions}

    comboProps={{ label: 'Categoria', options: categoriaOptions }}

    ></ComboBoxSearch>;
}

interface ICategoriaSelectorInput {
    appContext: AppContext;
    input: CustomInputIfc;
    hideLabel?:boolean;
    onBlurCustomInput: (customInput: CustomInputIfc) => void;
    providedList?: Categoria[];
    disabled?: boolean;
    onChangeExtended?: (entity: Categoria) => void;
    label?: string;
}

export const CategoriaSelectorInput = (props: ICategoriaSelectorInput) => {
    const { t, i18n } = useTranslation();
    const [currentCategoria, setCurrentCategoria] = React.useState<Categoria | undefined>(undefined);
    const [categoriaOptions, setCategoriaOptions] = React.useState<IComboBoxOption[]>([]);
    const categorias = useAsyncDataCourier(() =>
    props.providedList && props.providedList.length > 0
    ? Promise.resolve(props.providedList)
    : props.appContext.system.getCategoriasListForDropdown(),
    [],
    props.appContext.courier
    );
    const mapCategoriaOptions = (categorias: Categoria[]) => {
        const opciones = categorias.map((entity: Categoria) => {
            return { key: entity.getId()!, text: getLabelFromCategoria(entity) , data: entity };
        });
        setCategoriaOptions(opciones);
    };
    const selectDefaultCategoria = (id: string) => {
        setCurrentCategoria(categorias ? categorias.find((entity: Categoria) => entity.getId() === id) : undefined);
    };
    const forceUpdate = useForceUpdate();
    const getLabelFromCategoria = (entity: Categoria) => {
        const label = String( entity.getNombre()!);
        return label;
    }

    React.useEffect(() => {
        forceUpdate();
    }, [currentCategoria]);
    React.useEffect(() => {
        selectDefaultCategoria(props.input.getValue());
        mapCategoriaOptions(categorias ? categorias : []);
    }, [categorias, currentCategoria]);
    const onChangeExtended = () => {
        const _entity = categorias?.find((e) => e.getId() === props.input.getValue());
        if (_entity && props.onChangeExtended) {
            props.onChangeExtended(_entity);
        }

    };
    return (
    <>
    { categorias && (
    <ComboBoxInput
    input={props.input}

    label={props.hideLabel ? '' : props.label ? t(props.label) : t('Sin descriptor')}

    onBlur={props.onBlurCustomInput}

    options={ categoriaOptions ? categoriaOptions : []}

    onChangeExtended={onChangeExtended}

    />
    )}

    </>
    );
}

